import { GetContractTypes, GetAveStatus } from "@/services/contract.service.js";
import { GetAvailableTenants } from "@/services/contract.tenants.service.js";
import { GetAllNogaBranches } from "@/services/nogaBranches.service.js";

export const StammdatenMixin = {
  methods: {
    loadContractTypes() {
      GetContractTypes(
        response => {
          try {
            this.contractTypes = response.data || [];
          } catch (error) {
            console.error("Error loading contract types:", error);
            this.contractTypes = [];
          }
        },
        () => {}
      );
    },
    loadTenants() {
      GetAvailableTenants(
        response => {
          this.tenants = response;
        },
        () => {}
      );
    },

    loadAveStatus() {
      GetAveStatus(
        response => {
          this.aveStatus = response.data;
        },
        () => {}
      );
    },
    loadNogaBranches() {
      GetAllNogaBranches(
        response => {
          this.allNogaBranches = response;
        },
        () => {}
      );
    }
  }
};
